import indexStyles from '../sass/index.scss';
import mainSliderJS from './includes/main_slider';

import catalogItem1IMG from '../img/catalog-item-1.jpg';
import catalogItem2IMG from '../img/catalog-item-2.jpg';
import catalogItem3IMG from '../img/catalog-item-3.jpg';
